export const CHECKIN = 'check-in';
export const CHECKOUT = 'check-out';

export default Object.freeze([
  { id: CHECKIN, form: 'Checkin', update: 'update' },
  { id: CHECKOUT, form: 'Checkout', update: 'updateCheckout' },
]);
